module.exports = __webpack_public_path__ + "img/packet.a64de45a.gif";